// extracted by mini-css-extract-plugin
var _1 = "#709FFF";
var _2 = "#51545A";
var _3 = "#101B21";
var _4 = "#FEF3F2";
var _5 = "#FFFFFF";
var _6 = "#FFFCFA";
var _7 = "#ECFDF3";
var _8 = "#6A6E71";
var _9 = "#101B21";
var _a = "#FFFFFF";
var _b = "#FF6348";
var _c = "#E1E3E6";
var _d = "#92959B";
var _e = "#66DB86";
var _f = "#51545A";
var _10 = "#FFECE9";
var _11 = "#101B21";
var _12 = "#92959B";
var _13 = "#E2ECFF";
var _14 = "#66DB86";
var _15 = "#FF6348";
var _16 = "#FEF3F2";
var _17 = "#FFC248";
var _18 = "#F5F5F7";
var _19 = "#FFFFFF";
var _1a = "#EBEAFD";
var _1b = "#20883C";
var _1c = "#FFFFFF";
var _1d = "#5352EB";
var _1e = "#6A6E71";
var _1f = "#ECFDF3";
var _20 = "#6A6E71";
var _21 = "#51545A";
var _22 = "#2E3136";
var _23 = "#101B21";
var _24 = "#92959B";
var _25 = "#E1E3E6";
var _26 = "#F5F5F7";
var _27 = "#FFFCFA";
var _28 = "#6A6E71";
var _29 = "#C10097";
var _2a = "#2E3136";
var _2b = "#E1E3E6";
var _2c = "#66DB86";
var _2d = "#20883C";
var _2e = "#ECFDF3";
var _2f = "#5352EB";
var _30 = "#FFFFFF";
var _31 = "#FF6348";
var _32 = "#101B21";
var _33 = "#92959B";
var _34 = "#66DB86";
var _35 = "#FFF5ED";
var _36 = "#FFFFFF";
export { _1 as "aquamarine", _2 as "asphalt", _3 as "bgAlternate", _4 as "bgError", _5 as "bgPrimary", _6 as "bgSecondary", _7 as "bgSuccess", _8 as "bgTertiary", _9 as "black", _a as "borderAlternate", _b as "borderError", _c as "borderPrimary", _d as "borderSecondary", _e as "borderSuccess", _f as "borderTertiary", _10 as "bubbleGum", _11 as "charcoal", _12 as "coin", _13 as "cottonCandy", _14 as "emerald", _15 as "error", _16 as "errorLight", _17 as "eviteGold", _18 as "fog", _19 as "ghost", _1a as "lavender", _1b as "lime", _1c as "linkAlternate", _1d as "linkPrimary", _1e as "linkSecondary", _1f as "mint", _20 as "neutral", _21 as "neutralDark", _22 as "neutralDarker", _23 as "neutralDarkest", _24 as "neutralLight", _25 as "neutralLighter", _26 as "neutralLightest", _27 as "newVanilla", _28 as "pebble", _29 as "premiumColor", _2a as "shadow", _2b as "silver", _2c as "success", _2d as "successDark", _2e as "successLight", _2f as "tanzanite", _30 as "textAlternate", _31 as "textError", _32 as "textPrimary", _33 as "textSecondary", _34 as "textSuccess", _35 as "vanilla", _36 as "white" }
